import initialState from './initialState';
import {
  DISABLE_PERSONALIZED_GOOGLE_ADS,
  INITIALIZE_PERSONALIZED_GOOGLE_ADS,
  HIDE_GDPR_COOKIE_BANNER,
  INITIALIZE_GDPR_COOKIE_BANNER,
} from './actionTypes';

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case INITIALIZE_PERSONALIZED_GOOGLE_ADS:
      return { ...state, personalizedAds: payload.personalizedAds };
    case DISABLE_PERSONALIZED_GOOGLE_ADS:
      return { ...state, personalizedAds: false };
    case INITIALIZE_GDPR_COOKIE_BANNER:
      return {
        ...state,
        cookieBanner: {
          visible: payload.visible,
          url: payload.url,
        },
      };
    case HIDE_GDPR_COOKIE_BANNER:
      return payload.updateStore
        ? {
            ...state,
            cookieBanner: {
              ...state.cookieBanner,
              visible: false,
            },
          }
        : state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/Gdpr/reducer.js